import { useEffect, useState } from "react";
import instance from "../../../connection/instance";
import { notifications } from "@mantine/notifications";

const usePlaces = (t, navigate, searchParams) => {
  let queryName = 'status'
  let queryValue = -1

  for (const entry of searchParams.entries()) {
    const [param, value] = entry;
    
    if (param === 'sortName') {
      queryName = value
    }
    
    if (param === 'sortValue') {
      queryValue = Number(value)
    }
  }

  const [places, setPlaces] = useState([]);
  const [sortValue, setSortValue] = useState(queryValue);
  const [sortName, setSortName] = useState(queryName);
  const [filteredPlaces, setFilteredPlaces] = useState([]);

  const statuses = {
    RECALLED: {
      value: 5,
    },
    ON_REVIEW: {
      value: 0,
    },
    APPROVED: {
      value: 2,
    },
    PUBLISHED: {
      value: 2,
    },
    REJECTED: {
      value: 6,
    },
    READY_TO_PUBLISH: {
      value: 1,
    },
    INFORMATION_REQUIRED: {
      value: 3,
    },
    UNBOUND: {
      value: 4
    }
  }

  useEffect(() => {
    if (!sortValue) {
      return;
    }

    switch (sortName) {
      case 'name':
        sortNameFilter()
        break;

      case 'status':
        sortStatusFilter()
        break;

      case 'address':
        sortAdressFilter()
        break;

      default:
        break;
    }
  }, [sortName, sortValue, places])

  const sort = (name) => {
    if (!sortName) {
      setSortName(name)

      return
    }
  
    const value = sortValue === 1 ? -1 : 1

    if (sortName === name) {
      setSortValue(value);

      navigate(`/organizations?page=places&sortName=${name}&sortValue=${value}`, { replace: true })
      return;
    }

    setSortName(name);
    setSortValue(1);
    navigate(`/organizations?page=places&sortName=${name}&sortValue=1`, { replace: true })
  }

  const sortNameFilter = () => {
    filteredPlaces.sort((a, b) => {
      const aName = (a.place || a.claim).placeName;
      const bName = (b.place || b.claim).placeName;

      return aName > bName ? -1 * sortValue : 1 * sortValue;
    })

    setTimeout(() => {
      setFilteredPlaces([...filteredPlaces])
    }, 0)
  }

  const sortStatusFilter = () => {
    filteredPlaces.sort((a, b) => {
      if (a.status === b.status) {
        const aName = (a.place || a.claim).placeName;
        const bName = (b.place || b.claim).placeName;
  
        return aName > bName ? -1 * sortValue : 1 * sortValue;
      }

      return statuses[a.status].value > statuses[b.status].value ? -1 * sortValue : 1 * sortValue;
    })

    setTimeout(() => {
      setFilteredPlaces([...filteredPlaces])
    }, 0)
  }

  const sortAdressFilter = () => {
    filteredPlaces.sort((a, b) => {
      if (a.place?.placeAddress === b.place?.placeAddress) {
        if (statuses[a.status].value === statuses[b.status].value) {
          const aName = (a.place || a.claim).placeName;
          const bName = (b.place || b.claim).placeName;
    
          return aName > bName ? -1 * sortValue : 1 * sortValue;
        }

        return statuses[a.status].value > statuses[b.status].value ? -1 * sortValue : 1 * sortValue;
      }

      return (a.place?.placeAddress || '') > (b.place?.placeAddress || '') ? -1 * sortValue : 1 * sortValue;
    })

    setTimeout(() => {
      setFilteredPlaces([...filteredPlaces])
    }, 0)
  }

  const filterPlaces = (value) => {
    if (value.length === 0) {
      setFilteredPlaces(places);

      return;
    }

    setTimeout(() => {
      setFilteredPlaces(places.filter(({ place, claim }) => {
        const data = place || claim;
  
        return (
          data.placeName.toLowerCase().includes(value.toLowerCase())
          || data.placeAddress?.toLowerCase().includes(value.toLowerCase())
        )
      }))
    }, 0)
  }

  const fetchPlaces = async () => {
    const { data: { response, errors: fetchErrors } } = await instance.get('/api/place/list')

    if (fetchErrors?.length > 0) {
      throw { errors: fetchErrors }
    }

    setPlaces(response);
    setFilteredPlaces(response);
  }

  const createClaim = async (value) => {
    const { data: { response, errors: fetchErrors } } = await instance.post('/api/claims/new', value)

    if (fetchErrors?.length > 0) {
      fetchErrors.forEach(error => {
        switch (error.code) {
          case 'P050':
            notifications.show({
              title: t('notifications.permissionError'),
              autoClose: 2000
            });

            break;

          default:
            notifications.show({
              title: "Error:" + error.code + ":" + error.message,
              autoClose: 2000
            });
            break;
        }
      })

      return { errors: fetchErrors }
    }

    notifications.show({
      title: t('places.modalAdd.success'),
      autoClose: 2000
    })

    fetchPlaces();

    return response;
  }

  return [
    { places: filteredPlaces, sortValue, sortName },
    { fetchPlaces, createClaim, filterPlaces, sort }
  ]
}

export default usePlaces;
